// Map of events to pass through tagular
const eventMap = {
  PageViewed: 'redventures.usertracking.v2.WebContext',
  FormStarted: 'redventures.usertracking.v3.FormStarted',
  FormViewed: 'redventures.usertracking.v3.FormViewed',
  FormContinued: 'redventures.usertracking.v3.FormContinued',
  FormSubmitted: 'redventures.usertracking.v3.FormSubmitted',
  FormBacked: 'redventures.usertracking.v3.FormBacked',
  FormErrored: 'redventures.usertracking.v3.FormErrored',
  FormRestarted: 'redventures.usertracking.v3.FormRestarted',
  FormExited: 'redventures.usertracking.v3.FormExited',
  FormOutcomeReceived: 'redventures.usertracking.v3.FormOutcomeReceived',
  FieldInputted: 'redventures.usertracking.v3.FieldInputted',
  FieldSelected: 'redventures.usertracking.v3.FieldSelected',
  ProductClicked: 'redventures.ecommerce.v1.ProductClicked',
  ProductLoaded: 'redventures.ecommerce.v1.ProductLoaded',
  ProductViewed: 'redventures.ecommerce.v1.ProductViewed',
  ProductListSorted: 'redventures.ecommerce.v1.ProductListSorted',
  ProductListViewed: 'redventures.ecommerce.v1.ProductListViewed',
  ContentMetadataTracked: 'redventures.usertracking.v3.ContentMetadataTracked',
  ElementClicked: 'redventures.usertracking.v3.ElementClicked',
  ElementViewed: 'redventures.usertracking.v3.ElementViewed',
  PartnerAliasCaptured: 'redventures.usertracking.v1.PartnerAliasCaptured',
  CookieIdentified: 'redventures.browser.v1alpha.CookieIdentified',
  Alias: 'core.Alias.v1',
  Identify: 'core.Identify.v1',
};
// Function to fire a given tagular event
export const fireTagularEvent = (eventName, eventData) => {
  try {
    const payload = {
      '@type': eventMap[eventName],
      ...eventData,
    };
    window.top.tagular('beam', eventName, payload);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
};

export const elementClicked = (options = {}) => {
  const {
    position, location, elementType, text, actionOutcome,
  } = options;
  fireTagularEvent(
    'ElementClicked',
    {
      webElement: {
        position,
        location,
        elementType,
        text,
      },
      actionOutcome: actionOutcome || '',
    },
  );
};

export const elementViewed = (options = {}) => {
  const {
    position, location, elementType, text,
  } = options;
  fireTagularEvent(
    'ElementViewed',
    {
      webElement: {
        position,
        location,
        elementType,
        text,
      },
    },
  );
};

export const formViewed = (payload = null, options = {}) => {
  const formContext = {
    formType: payload.formType,
    formName: payload.formName,
    formId: payload.formId,
  };
  fireTagularEvent('FormViewed', { formContext }, options);
};

export const formSubmitted = (payload = null, options = {}) => {
  fireTagularEvent('FormSubmitted', payload, options);
};

export const identify = (payload = null, options = {}) => {
  fireTagularEvent('Identify', payload, options);
};

// export all the events
export default {
  fireTagularEvent,
  elementClicked,
  elementViewed,
  formViewed,
  formSubmitted,
  identify,
};
